export default __webpack_public_path__ + "static/media/government.3c99dedf.svg";